import { z } from 'zod';
import { emailSchema, membershipNumberSchema, nameSchema, optionalNameSchema, passwordSchema, phoneSchema, } from './common.js';
export const registerSchema = z
    .object({
    firstName: nameSchema,
    middleName: optionalNameSchema,
    lastName: nameSchema,
    email: emailSchema,
    phone: phoneSchema,
    membershipNumber: membershipNumberSchema,
    password: passwordSchema,
    confirmPassword: z.string(),
    acceptedTerms: z.literal(true, {
        errorMap: () => ({ message: 'You must accept the terms to register.' }),
    }),
    acceptedTermsVersion: z.string().min(1),
})
    .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match.',
    path: ['confirmPassword'],
});
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, 'Enter your password.'),
    /** Six-digit TOTP code, required for administrators once 2FA is enrolled. */
    totpCode: z
        .string()
        .trim()
        .regex(/^\d{6}$/, 'Enter the 6-digit code from your authenticator app.')
        .optional(),
    rememberMe: z.boolean().default(false),
});
export const refreshTokenSchema = z.object({
    refreshToken: z.string().min(1),
});
export const forgotPasswordSchema = z.object({ email: emailSchema });
export const resetPasswordSchema = z
    .object({
    token: z.string().min(1),
    password: passwordSchema,
    confirmPassword: z.string(),
})
    .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match.',
    path: ['confirmPassword'],
});
export const changePasswordSchema = z
    .object({
    currentPassword: z.string().min(1, 'Enter your current password.'),
    password: passwordSchema,
    confirmPassword: z.string(),
})
    .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match.',
    path: ['confirmPassword'],
})
    .refine((data) => data.currentPassword !== data.password, {
    message: 'Choose a password different from your current one.',
    path: ['password'],
});
export const verifyEmailSchema = z.object({ token: z.string().min(1) });
export const enable2faSchema = z.object({
    totpCode: z.string().trim().regex(/^\d{6}$/, 'Enter the 6-digit code.'),
});
export const disable2faSchema = z.object({
    password: z.string().min(1),
    totpCode: z.string().trim().regex(/^\d{6}$/, 'Enter the 6-digit code.'),
});
//# sourceMappingURL=auth.js.map